import React from 'react';
import { UserSwitch } from '@phosphor-icons/react';
import { Button } from './ui/button';
import { useAuth } from '../App';

export function ImpersonationBanner() {
  const { user, switchBack } = useAuth();
  
  if (!user?.impersonated_by) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-orange-500 text-black py-2 px-4 flex items-center justify-center gap-3 text-sm font-medium" data-testid="impersonation-banner">
      <UserSwitch weight="bold" className="w-5 h-5" />
      <span>Viewing as <strong>{user.name}</strong> ({user.email}) — Admin diagnostic mode</span>
      <Button
        size="sm"
        onClick={switchBack}
        className="bg-black text-white hover:bg-black/80 ml-2 h-7 text-xs px-3"
        data-testid="switch-back-btn"
      >
        Switch Back
      </Button>
    </div>
  );
}
